<div class="file-repository-summary">
  <div *ngIf="!selection" class="arm-summary">0 Items selected</div>
  <div *ngIf="selection?.length === 1 || selection" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="selection.name" class="arm-summary-value" fxFlex>{{selection.name}}</span>
    </div>

    <div [ngSwitch]="selection.status" class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Status:</span>
      <ng-container *ngSwitchCase="'ACTIVE'">
        <span matTooltip="Active"><i class="fa fa-check file-repository-status active"></i></span>
      </ng-container>
      <ng-container *ngSwitchCase="'INITIALIZING'">
        <span matTooltip="Initializing"> <i class="fa fa-refresh file-repository-status initializing"></i></span>
      </ng-container>
      <ng-container *ngSwitchCase="'ERROR'">
        <span matTooltip="Error"> <i class="fa fa-exclamation file-repository-status error"></i></span>
      </ng-container>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Number of users:</span>
      <span [title]="selection.numberOfUsers" class="arm-summary-value" fxFlex>{{selection.numberOfUsers}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Delimiter:</span>
      <span [title]="selection.delimiter" class="arm-summary-value" fxFlex>{{selection.delimiter}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Update info:</span>
      <span [title]="selection.description" class="arm-summary-value" fxFlex>{{selection.description}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Last:</span>
      <span [title]="selection.numOfUsers" class="arm-summary-value" fxFlex>{{selection.lastTimestamp | date : 'MMM d, y HH:mm:ss'}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Mappings:</span>
    </div>

    <div class="summary-mappings" *ngFor="let mapping of selection.dicAttrMapping" >
      <span class="servers-details-mapping-from" fxFlex="45">{{selection.isFileHasHeaders ? mapping.fileRepositoryAttrName : mapping.fileRepositoryAttrLocation + 1}}</span>
      <span class="servers-details-mapping-arrow"><i class="fa fa-long-arrow-right"></i></span>
      <span class="servers-details-mapping-to" fxFlex>{{mapping.dicAttrName}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Normalization:</span>
    </div>

    <div class="summary-mappings" *ngFor="let mapping of selection.dicAttrMapping" >
      <div *ngIf="mapping.normalizationGroupId">
        <span class="servers-details-mapping-from" [title]="selection.isFileHasHeaders ? mapping.fileRepositoryAttrName : mapping.fileRepositoryAttrLocation + 1">
          {{selection.isFileHasHeaders ? mapping.fileRepositoryAttrName : mapping.fileRepositoryAttrLocation + 1}}</span>
        <span class="servers-details-mapping-arrow"><i class="fa fa-long-arrow-right"></i></span>
        <span class="servers-details-mapping-to"
              [title]="getNormalizationGroupName(mapping.normalizationGroupId)">
                        {{getNormalizationGroupName(mapping.normalizationGroupId)}}
                    </span>
      </div>
    </div>

  </div>
</div>
